import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { SplineChart as BaseSplineChart } from '../../../../../../CommonComponents/OPL/charts/SplineChart/SplineChart';
import { WrapperProps } from '../../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { EstimatedPerformanceDTO } from '../../../../api/useGetWorkflowResultsQuery';
import { Tooltip } from '../Tooltip/Tooltip';
import { commonSettings } from '../../../../../../CommonComponents/OPL/charts/charts.constants';

interface Props extends WrapperProps {
  series: EstimatedPerformanceDTO['series'];
  categories: string[];
}

export const SplineChart: React.FC<Props> = ({ series, categories }) => {
  const seriesWithName = series.map(({ label, data: dataPoints, color }) => ({
    name: label,
    data: dataPoints,
    color,
  }));

  const chartConfig = {
    xAxis: {
      labels: {
        step: categories.length - 1,
      },
    },
    yAxis: {
      opposite: true,
    },
    tooltip: {
      shared: true,
      ...commonSettings.tooltip,
      formatter() {
        return ReactDOMServer.renderToStaticMarkup(<Tooltip points={(this as any).points} />);
      },
    },
  };

  return (
    <BaseSplineChart series={seriesWithName} categories={categories} customSettings={chartConfig} />
  );
};
